require("promise-polyfill/dist/polyfill");
// 第三方插件/库
window.$ = window.jQuery = require('jquery');
require("bootstrap");
require("layui-layer/dist/layer");
require("easy-autocomplete/dist/jquery.easy-autocomplete");
window.Cookies = require("js-cookie");
// require("swiper");
window.QRCode = require('qrcodejs-module');


// 开发模块
if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) { // 手机PC分开 common
	require('./_partial/_common_mobile');
	require('./wxShareCom');
} else {
	require('./_partial/_common_pc');
}

require('./_partial/global');
require('./_partial/_common');
require('./_partial/_seo_source');
require('./_partial/_user_recording');
require('./_partial/_unveil');
require('./_partial/_autocomplete');
require('./_partial/_question');
require('./_partial/_product_info_tocart');
require('./_partial/_variant');
require('./_partial/_coupon');
require('./_partial/_filter');
require('./_partial/_ajax_product');
require('./_partial/_gioAction');
require('./_partial/_smart_recommend');
require('./_partial/_popup');
require('./_partial/_dialog');
require('./_partial/_pos');
require('./_partial/_popper');
require('./_partial/_draw_lottery');
require('./_partial/_userAPI');
require('./_partial/_light-reg');
require('./_partial/_set_url');
require('./_partial/_live_icon');
require('./_partial/_cookie_Popup');
require('./_partial/_show_back_live_btn');
require('./_partial/_member_center_services');
require('./_partial/_utm');
require('./login/login-dialog');
require('./login/regist-easy-completion-dialog');
require('./selectCompany');
